import React from 'react';

const palette = [
  { bg: 'bg-sage-50', text: 'text-sage-800' },
  { bg: 'bg-terracotta-50', text: 'text-terracotta-700' },
  { bg: 'bg-amber-50', text: 'text-amber-800' },
  { bg: 'bg-sky-50', text: 'text-sky-700' },
  { bg: 'bg-sand-100', text: 'text-sand-800' },
];

const hash = (s: string) => {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (s.charCodeAt(i) + ((h << 5) - h)) | 0;
  return Math.abs(h);
};

interface AvatarProps {
  name: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClass = {
  sm: 'w-7 h-7 text-[11px]',
  md: 'w-9 h-9 text-xs',
  lg: 'w-11 h-11 text-sm',
};

export const Avatar: React.FC<AvatarProps> = ({
  name,
  size = 'md',
  className = '',
}) => {
  const initials = name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((n) => n[0]?.toUpperCase() || '')
    .join('');
  const tone = palette[hash(name) % palette.length];
  return (
    <span
      className={[
        'inline-flex items-center justify-center rounded-full font-medium',
        tone.bg,
        tone.text,
        sizeClass[size],
        className,
      ].join(' ')}
    >
      {initials || '?'}
    </span>
  );
};
